import { useDrag } from 'react-dnd';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react';
import { TimelineDraggableCollectedProps, TimelineDragObject, TimelineItemTypeType } from '@app-types/timetable';

interface HSMSDraggableItemWrapperProps {
  disabled: boolean;
}

interface HSMSDraggableItemProps {
  children: React.ReactElement;
  id: string;
  draggableType: string;
  duration: number;
  title: string;
  color: string;
  elementID?: string;
  canDrag?: boolean;
  itemType: TimelineItemTypeType;
  lecturerID?: string;
  subjectName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useMst: () => { timetable?: any };
}

const HSMSDraggableItemWrapper = styled.div<HSMSDraggableItemWrapperProps>`
  background-color: ${({ color }) => color};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: move;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 13px 8px;
  margin: 8px 5px;
  width: auto;
  border: 1px solid ${({ color }) => color};
  box-shadow: 0 0 0 2px ${({ color }) => color};
  -webkit-transition: border-color 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);

  .name-tag {
    color: white;
    font-size: 0.7rem;
    font-weight: 500;
  }

  &.selected-draggable-item {
    border-color: #ffffff;
  }
`;

export const HSMSDraggableItem = observer(
  ({
    children,
    id,
    draggableType,
    duration,
    title,
    color,
    elementID,
    canDrag,
    itemType,
    lecturerID,
    subjectName,
    useMst,
  }: HSMSDraggableItemProps) => {
    const { dragHoverTime, selectedDraggableItem } = useMst().timetable;
    const [{ isDragging }, drag] = useDrag<TimelineDragObject, void, TimelineDraggableCollectedProps>({
      item: {
        type: draggableType,
        id,
        duration,
        title,
        color,
        elementID,
        itemType,
        lecturerID,
        subjectName,
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      canDrag: () => selectedDraggableItem && selectedDraggableItem.split('/')[1] === id,
    });

    let disabled = isDragging;

    if (canDrag !== undefined && !canDrag) {
      disabled = true;
    }

    return (
      <HSMSDraggableItemWrapper
        color={color}
        ref={drag}
        disabled={disabled}
        className={selectedDraggableItem === `${itemType}/${id}` ? 'selected-draggable-item' : ''}
      >
        <Tooltip title={dragHoverTime} visible={isDragging && dragHoverTime !== null}>
          {children}
        </Tooltip>
      </HSMSDraggableItemWrapper>
    );
  },
);
